/**
 * RM-430 — the member's own "RM via text" tile on their Profile and the page it
 * opens, from GET /agent/sms/me.
 *
 * They show when texting is on (status and RM's number), or when the app way
 * is open (`available`; off in production until Twilio approves it) and the
 * member can turn it on, or can't for a reason they can act on themselves.
 */

/** Reasons the page explains, because the member can fix them. */
export const ACTIONABLE_REASONS = ['no_mobile', 'opted_out']

/**
 * @param {{ on?: boolean, available?: boolean, canTurnOn?: boolean, reason?: string|null }|null} state
 * @returns {boolean}
 */
export function rmViaTextVisible(state) {
  if (!state)
    return false
  if (state.on)
    return true

  return !!state.available && (!!state.canTurnOn || ACTIONABLE_REASONS.includes(state.reason))
}
